module.exports = __webpack_public_path__ + "static/feature-1-6b2a1b8c2bdfc7a9c00ca25202317c68.svg";